const documentStyle = getComputedStyle(document.documentElement);

export function getThemeColor(cssVariable: string): string {
    return documentStyle.getPropertyValue(cssVariable.replace('var(', '').replace(')', ''));
}
